export enum SlotCode {
  JobsBasic = 'SLOTJOBSBASIC',
  JobsAdvanced = 'SLOTJOBSADVANCED',
  JobsUltimate = 'SLOTJOBSULTIMATE',
  JobsUltimatePlus = 'SLOTJOBSULTIMATEPLUS',
  JobupBasic = 'SLOTJOBUPBASIC',
  JobupAdvanced = 'SLOTJOBUPADVANCED',
  JobupUltimate = 'SLOTJOBUPULTIMATE',
  JobupUltimatePlus = 'SLOTJOBUPULTIMATEPLUS',
}

/** Narrows a product code to a slot code. */
export const isSlotCode = (value: unknown): value is SlotCode =>
  Object.values(SlotCode).includes(value as SlotCode);
